import { connect } from 'react-redux';
import ListItemActionButton from '../../../components/ListItem/ActionButton';

export default connect()(ListItemActionButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ListItem/ActionButton/index.tsx